module.exports = __webpack_public_path__ + "img/x_letter_b.afff2a38.svg";